import { createContext, useContext, ReactNode } from "react";

// Define the shape of our context
export interface PreviewContextType {
  // Feature flags
  isPreview?: boolean;
}

// Create the context with default values
const PreviewContext = createContext<PreviewContextType>({
  isPreview: false,
});

// Custom hook to use the preview context
export const usePreviewContext = () => useContext(PreviewContext);

// Provider props
interface PreviewProviderProps {
  children: ReactNode;
  value: boolean;
}

// Provider component
export const PreviewProvider: React.FC<PreviewProviderProps> = ({
  children,
  value,
}) => {
  // Merge default values with provided values
  const contextValue: PreviewContextType = {
    isPreview: value,
  };

  return (
    <PreviewContext.Provider value={contextValue}>
      {children}
    </PreviewContext.Provider>
  );
};
